<template>
  <div class="bread__index--page" @scroll="pageScroll" ref="appIndexPageRef">
    <div class="index__nav--bar">
      <div class="hidden-xs-only nav__info">
        <img class="nav__image" src="@/assets/app_logo.png" alt="" />
        <img class="nav__name" src="@/assets/app_name.png" alt="" />
        <div class="introduce flex items-center justify-center">
          <div :class="['intro__item', tabIndex === 1 && 'active']" @click="changeMove(1)">首页</div>
          <div :class="['intro__item', tabIndex === 2 && 'active']" @click="changeMove(2)">关于</div>
          <div :class="['intro__item', tabIndex === 3 && 'active']" @click="changeMove(3)">联系我们</div>
        </div>
      </div>

      <div class="nav__small hidden-sm-and-up">
        <img class="nav__image" src="@/assets/app_logo.png" alt="" />
        <div class="app__title">
          <img class="nav__title" src="@/assets/app_title_small.png" alt="" />
        </div>
      </div>
    </div>

    <div class="w-full hidden-xs-only">
      <div :class="['max__height', showBar && 'show__bar']"></div>
      <div class="model__0" :style="{ backgroundImage: `url(${require('@/assets/index_big_bg.png')})` }">
        <div class="model__color big__color flex items-center justify-center flex-col">
          <div class="text__3 mb-4">视频素材快速裂变</div>
          <div class="text__4">不靠低质的混剪技巧对抗平台</div>
          <div class="text__4">而是通过真正的内容修改来创造价值</div>
          <div class="login__btn btnHover flex items-center justify-center mt-10" @click="showLogin">立即尝试</div>
        </div>
      </div>

      <div id="aboutOwnerId" class="relative model__ower big__ower flex items-center justify-center flex-col">
        <div class="text__5 mb-7">关于我们</div>
        <div class="text__6">
          Breed专注于为企业与个人提供AI原生的视频素材编辑服务，致力于构建定制化的AI视频生产线，以满足不同用户的独特需求。我们为用户提供包括AI视频换脸、AI视频去字幕以及AI视频对口型等在内的智能产品服务。
        </div>
      </div>

      <div id="linkOwnerId" class="model__link big__link flex items-center justify-center flex-col">
        <div class="link__mine">联系我们</div>
        <div class="link__desc flex items-start">
          <span class="link__label flex-shrink-0">地址：</span><span class="flex-1">深圳市南山区前海香槟国际金融中心1909A</span>
        </div>
        <div class="link__desc"><span class="link__label">邮箱：</span>mld@originalcity.xyz</div>
        <img class="link__code" src="@/assets/index_small_code.png" alt="" />
        <div class="mt-6" style="font-size: 28px">扫码加微信</div>
      </div>

      <div
        class="model__footer big__footer flex items-center justify-between flex-col"
        :style="{ backgroundImage: `url(${require('@/assets/index_big_footer.png')})` }"
      >
        <div class="flex-1 flex items-center justify-center">
          <img class="footer__icon1" src="@/assets/index_small_icon1.png" alt="" />
        </div>
        <div class="footer__bar flex-shrink-0 w-full flex items-center justify-center flex-col">
          <div class="mb-1">Copyright © 2024 逗花科技（深圳）有限公司</div>
          <div>版权所有 <a class="hover:underline" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024260843号-1</a></div>
        </div>
      </div>
    </div>

    <div class="w-full index__small hidden-sm-and-up">
      <div :class="['max__height samll__h', showBar && 'show__bar']"></div>
      <div class="model__0" :style="{ backgroundImage: `url(${require('@/assets/index_small_bg.png')})` }">
        <div class="model__color flex items-center justify-center flex-col">
          <div class="text__3 mb-1.5">视频素材快速裂变</div>
          <div class="text__4">不靠低质的混剪技巧对抗平台</div>
          <div class="text__4">而是通过真正的内容修改来创造价值</div>
          <div class="login__btn flex items-center justify-center mt-4" @click="showLogin">立即尝试</div>
        </div>
      </div>
      <div class="relative model__ower flex items-center justify-center flex-col">
        <div class="text__5 mb-5">关于我们</div>
        <div class="text__6">
          Breed专注于为企业与个人提供AI原生的视频素材编辑服务，致力于构建定制化的AI视频生产线，以满足不同用户的独特需求。我们为用户提供包括AI视频换脸、AI视频去字幕以及AI视频对口型等在内的智能产品服务。
        </div>
      </div>

      <div class="model__link flex items-center justify-center flex-col">
        <div class="link__mine">联系我们</div>
        <div class="link__desc flex items-start">
          <span class="link__label flex-shrink-0">地址：</span><span class="flex-1">深圳市南山区前海香槟国际金融中心1909A</span>
        </div>
        <div class="link__desc"><span class="link__label">邮箱：</span>mld@originalcity.xyz</div>
        <img class="link__code" src="@/assets/index_small_code.png" alt="" />
        <div class="mt-3">扫码加微信</div>
      </div>

      <div class="model__footer flex items-center justify-between flex-col" :style="{ backgroundImage: `url(${require('@/assets/index_small_footer.png')})` }">
        <div class="flex-1 flex items-center justify-center">
          <img class="footer__icon1" src="@/assets/index_small_icon1.png" alt="" />
        </div>
        <div class="footer__bar flex-shrink-0 w-full flex items-center justify-center flex-col">
          <div class="mb-1">Copyright © 2024 逗花科技（深圳）有限公司</div>
          <div>版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024260843号-1</a></div>
        </div>
      </div>
    </div>

    <LoginModal />
  </div>
</template>

<script>
import qs from 'qs'
import LoginModal from '@/components/loginModel/index.vue'

export default {
  components: { LoginModal },

  data() {
    return {
      showBar: false,
      tabIndex: 1,
      aboutTop: 0,
      linkTop: 0
    }
  },

  computed: {},

  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler: function () {
        this.dealQuery()
      }
    }
  },

  mounted() {
    this.$store.commit('LOGOUT_APP')
    this.getElementDistance()
  },

  methods: {
    showLogin() {
      this.$store.commit('SET_KEY', { key: 'showLoginModal', value: true })
    },

    pageScroll(event) {
      const top = event.target.scrollTop
      this.showBar = top > 99
      if (top >= this.linkTop) {
        this.tabIndex = 3
      } else if (top >= this.aboutTop) {
        this.tabIndex = 2
      } else {
        this.tabIndex = 1
      }
    },

    changeMove(index) {
      if (index === 3) {
        this.$refs.appIndexPageRef.scrollTop = this.linkTop + 200
      } else if (index === 2) {
        this.$refs.appIndexPageRef.scrollTop = this.aboutTop + 200
      } else {
        this.$refs.appIndexPageRef.scrollTop = 0
      }
    },

    getElementDistance() {
      const ablout = document.getElementById('aboutOwnerId')
      const link = document.getElementById('linkOwnerId')
      if (ablout) {
        this.aboutTop = ablout.getBoundingClientRect().top - 200
        this.linkTop = link.getBoundingClientRect().top - 200
      }
    },

    dealQuery() {
      let redirect = this.$route.query.redirect
      console.log('进来了吗', this.$route.query)
      if (redirect) {
        redirect = redirect.split('?')[1]
        if (redirect) {
          const query = qs.parse(redirect)
          if (query.needRegPhoneNumber && query.openid) {
            this.$store.commit('SET_KEY', { key: 'showLoginModal', value: true })
            this.$store.commit('SET_KEY', { key: 'loginModalInfo', value: query })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bread__index--page {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  scroll-behavior: smooth;

  .max__height {
    height: 90px;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 10;
    transition: all 1s;
    opacity: 0;

    &.show__bar {
      opacity: 1;
    }

    &.samll__h {
      height: 52px;
    }
  }

  .con__max {
    width: 100%;
    height: 100%;
    max-width: $indexMaxWidth;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // background-color: red;
  }

  .remake {
    width: 100%;
    height: 400px;
    display: flex;
    flex-direction: column;
    padding-top: 120px;
  }

  .text__1 {
    width: 600px;
    height: 340px;
    // background-color: green;
    color: #fff;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    text-align: left;

    .small__text {
      color: #fff;
      font-family: 'PingFang SC';
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
    }
  }

  .remake__promote {
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    padding-bottom: 21px;

    &.color1 {
      color: #000;
    }

    &.color2 {
      color: #fff;
    }
  }

  .remake__fission {
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 400;

    &.co1 {
      color: #000;
    }
    &.co2 {
      color: #fff;
    }
  }

  .competition {
    width: 100%;
    height: 605px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &.ash {
      background-color: #272727;
    }

    &.orange {
      background-color: #e35f47;
    }

    &.yellow {
      background-color: #c49029;
    }

    .competition__cycle {
      color: #fff;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 40px;
      font-style: normal;
      font-weight: 600;
      padding-bottom: 21px;
      &.pb {
        padding-bottom: 45px;
      }
    }

    .competition__text {
      color: #fff;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
    }
  }

  .chiyuan {
    width: 100%;
    height: 392px;
    flex-shrink: 0;
    background-color: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .chiyuan__box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      padding-bottom: 63px;

      .chiyuan__neo {
        width: 356px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .chiyuan__title {
          display: flex;
          flex-direction: column;
          text-align: left;

          .chiyuan__text {
            color: #fff;
            font-family: 'PingFang SC';
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            padding-bottom: 17px;

            &.textColor {
              color: #666;
            }
          }
        }
      }

      .toolbar__butt {
        display: flex;
        flex-direction: column;

        .toolbar__neo {
          width: 289px;
          height: 57px;
          flex-shrink: 0;
          margin-bottom: 15px;
        }

        .toolbar__two {
          width: 210px;
          height: 57px;
          flex-shrink: 0;
        }
      }
    }

    .copyright {
      color: #fff;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
  }

  .model__0 {
    width: 100%;
    height: 100vh;
    background-size: 100% 100%;
    position: relative;

    .model__color {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.16) 100%);

      .text__3 {
        font-size: 35px;
        font-weight: 600;
        color: #fff;
        line-height: 52px;
      }

      .text__4 {
        color: #fff;
        text-align: center;
        font-family: 'PingFang SC';
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        opacity: 0.8;
      }

      .login__btn {
        width: 146px;
        height: 49px;
        border-radius: 6px;
        border: 2px solid #fff;
        color: #fff;
        text-align: center;
        font-family: 'PingFang SC';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        cursor: pointer;
        user-select: none;
      }

      &.big__color {
        .text__3 {
          font-size: 70px;
          line-height: 100px;
        }

        .text__4 {
          font-size: 22px;
          line-height: 34px;
        }

        .login__btn {
          width: 292px;
          height: 98px;
          flex-shrink: 0;
          border-radius: 10px;
          border: 4px solid #fff;
          font-size: 36px;
          line-height: 52;
        }
      }
    }
  }

  .model__ower {
    background-color: #eaeaea;
    width: 100%;
    height: 349px;

    .text__5 {
      color: #333;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 35px;
      font-style: normal;
      font-weight: 600;
      line-height: 50px;
    }

    .text__6 {
      width: 100%;
      color: #333;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding: 0 40px;
    }

    &.big__ower {
      height: 698px;
      background-color: #dce1ed;

      .text__5 {
        font-size: 70px;
        line-height: 100px;
      }

      .text__6 {
        width: 592px;
        padding: 0 20px;
        font-size: 20px;
      }
    }
  }

  .model__link {
    width: 100%;
    height: 537px;
    background-color: #fff;

    .link__mine {
      color: #333;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 35px;
      font-style: normal;
      font-weight: 600;
      line-height: 50px;
      margin-bottom: 26px;
    }

    .link__desc {
      color: #000;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width: 200px;

      .link__label {
        font-weight: 600;
      }
    }

    .link__code {
      width: 135px;
      height: 135px;
      margin-top: 26px;
    }

    &.big__link {
      height: 938px;

      .link__mine {
        font-size: 70px;
        line-height: 100px;
        margin-bottom: 70px;
      }

      .link__desc {
        font-size: 26px;
        line-height: 38px;
        width: 600px;
      }

      .link__code {
        width: 270px;
        height: 270px;
        margin-top: 70px;
      }
    }
  }

  .model__footer {
    width: 100%;
    height: 194px;
    background-size: 100% 100%;

    .footer__icon1 {
      width: 94px;
    }

    .footer__bar {
      height: 72px;
      background-color: #000;
      color: #fff;
      font-family: 'PingFang SC';
      font-size: 12px;
      font-weight: 400;
    }

    &.big__footer {
      height: 387px;

      .footer__icon1 {
        width: 188px;
      }

      .footer__bar {
        height: 164px;
        color: #999;
        font-size: 20px;
      }
    }
  }

  .index__small {
    width: 100%;
    overflow: hidden;
  }
}

.index__nav--bar {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 99;

  .nav__small {
    height: 52px;
    width: 100%;
    max-width: $indexMaxWidth;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 17px;
    position: relative;

    .nav__image {
      // width: 25px;
      height: 38px;
      flex-shrink: 0;
    }

    .login__text {
      color: #999;
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }

    .nav__title {
      width: 94px;
    }

    .app__title {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-family: Rakkas;
      font-size: 19px;
      font-weight: 600;
    }
  }

  .nav__info {
    height: 90px;
    width: 100%;
    padding: 0 29px;
    // max-width: $indexMaxWidth;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .nav__image {
      width: 58px;
      flex-shrink: 0;
    }

    .nav__name {
      width: 188px;
      flex-shrink: 0;
      margin-left: 10px;
    }

    .introduce {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;

      .intro__item {
        color: #fff;
        text-align: center;
        font-family: 'PingFang SC';
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        width: 180px;
        text-align: center;
        cursor: pointer;
        user-select: none;
        position: relative;

        &:hover {
          opacity: 0.8;
        }

        &::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          height: 3px;
          width: 0px;
          border-radius: 4px;
          background-color: #fff;
          transition: all 0.4s;
        }

        &.active {
          &::after {
            width: 42px;
          }
        }
      }
    }

    .gavin {
      color: #999;
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }

    .login__btn {
      width: 70px;
      height: 30px;
      flex-shrink: 0;
      border-radius: 6px;
      border: 1px solid #999;
      color: #999;
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }
  }
}
</style>
